export class AuthError extends Error {
  constructor(
    public errorCode: string,
    public errorMessage: string
  ) {
    super(errorMessage);
    this.name = 'AuthError';
  }
}
